import { getDateFromString } from './helpers';

export const TYPES = {
  OR_CAMPER_ADD: 'OR-camper-add', // (not in old) Before adding cart participant
  OR_CAMPER_ADDED: 'OR-camper-added', // (not in old) After adding cart participant
  OR_CAMPER_EMAIL: 'OR-camper-email', // When camper email changes (not in old app)
  OR_CAMPER_DURATION: 'OR-camper-duration', // When program length is changed via tabs
  OR_CAMPER_BOARDING: 'OR-camper-boarding', // When boarding changes
  OR_CAMPER_CALENDAR: 'OR-camper-calendar', // When camps are loaded with /seasons endpoint
  OR_CAMPER_INFORMATION: 'OR-camper-information', // When camper finishes all info, then when parent/position/shirt changes
  OR_CAMPER_PROGRAM: 'OR-camper-program', // When camp is selected
  OR_CAMPER_GEAR: 'OR-camper-gear', // When gear is added (not in old app)
  OR_CART_APPROVED: 'OR-cart-approved', // // When cart is approved, replaces old OR-cart
  OR_CART_ADD: 'OR-cart-add', // When we add a product to cart
};

let instance = null;

class GTMService {
  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }

  init(settings, store) {
    this.settings = settings;
    this.store = store;
  }

  trackAddToCart = (product, productType) => {
    const { form } = this.store.getState();
    const sport = this.settings.sport || form.sport;

    const data = {
      event: 'newEvent',
      newEventData: {
        params: {
          url: `${window.location.href}`,
          type: productType,
          date: product.start_date || product.capacity_start_date,
          name: product.name || product.program_type,
          price: product.price,
        },
        title: document.title,
        type: TYPES.OR_CART_ADD,
        language: 'en',
        url: window.location.href,
        sport,
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };

  trackChange = (type) => {
    const { form, cart } = this.store.getState();
    const sport = this.settings.sport || form.sport;

    const data = {
      event: 'newPage',
      newPageData: {
        params: {
          age: form.camper.age,
          boarding: form.boarding ? 'Boarding' : 'Non-Boarding',
          business_type: this.settings.businessType,
          gender: form.camper.gender,
          length_program: form.programLengthInWeeks,
          package_type: this.settings.packageType,
          refundable: form.refundable,
          sport,
        },
        title: document.title,
        type: type,
        language: 'en',
        url: `${window.location.href}`,
        sport,
      },
      newUserData: {
        billing: {
          address: null,
          contact_number: null,
          coupon_number: null,
          coupon_code: null,
          coupon_data: [],
          email: cart.email,
          first_name: cart.first_name,
          last_name: cart.last_name,
          price_total: cart.price_total,
          total_discount: cart.total_discount,
        },
        campers: [
          {
            id: null,
            created: null,
            updated: null,
            address: null,
            first_name: form.parent.firstName,
            last_name: form.parent.lastName,
            email: form.parent.email,
            phone: form.parent.phoneNumber,
            medical_waiver: null,
            preferred_shirt_size: form.camper.shirtSize,
            // preferred_short_size: state.shirt_size,
            dob: form.camper.birthdate
              ? getDateFromString(form.camper.birthdate).getTime() / 1000
              : null,
            gender: form.camper.gender,
            position: form.camper.secondaryPositionName,
            price_total: cart.price_total,
            age: form.camper.age,
            quantity: 1,
          },
        ],
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };
}

export default GTMService;
